import { useTranslation } from "react-i18next";
import type { Analytics } from "../../api";
import { fmtMoney } from "../../lib/format";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { EmptyState } from "../ui/empty-state";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";

export function TopClientsCard({ rows }: { rows: Analytics["top_clients"] }) {
  const { t } = useTranslation("analytics");
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <CardTitle className="text-base">{t("topClients.title")}</CardTitle>
          <p className="text-xs text-muted-foreground">{t("topClients.subtitle")}</p>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        {rows.length === 0 ? (
          <EmptyState title={t("empty.noWorks")} className="py-8" />
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t("topClients.columns.client")}</TableHead>
                <TableHead className="text-right">{t("topClients.columns.works")}</TableHead>
                <TableHead className="text-right">{t("topClients.columns.revenue")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((c) => (
                <TableRow key={c.client_id}>
                  <TableCell className="font-medium">{c.full_name}</TableCell>
                  <TableCell className="text-right tabular-nums">{c.works_count}</TableCell>
                  <TableCell className="text-right tabular-nums">{fmtMoney(c.revenue)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
